<ol class="flex items-center w-full">
  <ng-content></ng-content>
</ol>
